<template>
  <div class="container">
    <div v-if="loading" class="loading"></div>

    <template v-else>
      <div :key="buildingListingKey" v-if="showNoAvailabilityErrorMessage === false" class="apartment-block-listing" id="apartments">
        <div class="apartment-block" v-for="(building, key) in filteredBuildings" :key="key">
          <div class="apartment-block-images">
            <slick
                ref="slick"
                :options="slickOptions"
                class="image-slider"
            >
              <img alt="{{ building.title }}" src="data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==" v-for="(image, imageKey) in buildingImages(building)" :key="imageKey" :data-src="image" class="object-fit lazyload">
            </slick>
          </div>
          <div class="apartment-block-content">
            <div class="inner">
              <p class="provider" v-if="building.group && wpData.group_icons[building.group]">
                <img :src="wpData.group_icons[building.group]" :alt="Object.keys(wpData.groups).find((groupKey) => wpData.groups[groupKey] === building.group)">
              </p>
              <h3><a :href="building.permalink | formatPermalink">{{ building.title }}</a></h3>
              <p class="location-tag">
                <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><title>pin</title><path fill="#FC6A1E" d="M24,45.693a1.977,1.977,0,0,1-1.575-.775C19.04,40.545,8,25.7,8,18.307a16,16,0,0,1,32,0c0,7.4-11.04,22.238-14.424,26.61A1.979,1.979,0,0,1,24,45.693ZM24,4.307a14.015,14.015,0,0,0-14,14c0,5.372,7.235,16.636,14.006,25.387C30.765,34.943,38,23.679,38,18.307A14.015,14.015,0,0,0,24,4.307Z"/><path fill="#FC6A1E" d="M23.967,22.484a3.978,3.978,0,1,1,3.978-3.978A3.982,3.982,0,0,1,23.967,22.484Zm0-5.956a1.978,1.978,0,1,0,1.978,1.978A1.98,1.98,0,0,0,23.967,16.528Z"/></svg>
                {{ building.location_text }}
              </p>
            </div>
            <div class="block-specs mob-bottom">
              <div class="feat">
                <svg width="32" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><title>bed</title><path d="M42.854,21.512v-11.5a1,1,0,0,0-1-1H6.156a1,1,0,0,0-1,1V21.5A2.99,2.99,0,0,0,4,23.853V34.888a1,1,0,0,0,1,1H8.411v2.105a1,1,0,0,0,2,0V35.888H37.469v2.105a1,1,0,0,0,2,0V35.888H43a1,1,0,0,0,1-1V23.853A2.986,2.986,0,0,0,42.854,21.512ZM6,23.853a1,1,0,0,1,1-1H41a1,1,0,0,1,1,1V26.37H6Zm6-4v-3a1,1,0,0,1,1-1h7.307a1,1,0,0,1,1,1v3a1,1,0,0,1-1,1H13A1,1,0,0,1,12,19.851Zm14.693,0v-3a1,1,0,0,1,1-1H35a1,1,0,0,1,1,1v3a1,1,0,0,1-1,1H27.693A1,1,0,0,1,26.693,19.851ZM7.156,11.007h33.7v9.844H37.816a2.966,2.966,0,0,0,.184-1v-3a3,3,0,0,0-3-3H27.693a3,3,0,0,0-3,3v3a2.967,2.967,0,0,0,.185,1H23.122a2.967,2.967,0,0,0,.185-1v-3a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v3a2.966,2.966,0,0,0,.184,1H7.156ZM6,33.888V28.37H42v5.518Z"/></svg>
                <p>{{ buildingBedroomsText(building) }}</p>
              </div>
              <div class="feat no-border">
                <svg width="32" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><title>user</title><path d="M28.838,23.607a10.167,10.167,0,1,0-9.676,0A15.687,15.687,0,0,0,8.333,38.5h2a13.667,13.667,0,0,1,27.334,0h2A15.687,15.687,0,0,0,28.838,23.607Zm-13-8.94A8.167,8.167,0,1,1,24,22.833,8.177,8.177,0,0,1,15.833,14.667Z"/></svg>
                <p>Up to {{ highestMaximumOccupancyExcludingInfants(building) }} {{ $t('guests') }}</p>
              </div>
              <a :href="building.permalink | formatPermalink" class="button has-icon">
                {{ $t('view') }}
                <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><title>arrow-right-alt</title><path fill="#fff" d="M27.9,33.432l-1.417-1.411,7.309-7.339H11.792v-2H33.81l-7.332-7.366L27.9,13.905l8.316,8.349a2.008,2.008,0,0,1,0,2.829Z"/></svg>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div v-else>
        <p class="error-message">{{ $t('no_availability') }}</p>
      </div>
    </template>

    <!-- <availability-filters
      v-if="features !== null && group !== null && numberOfAdults !== null && numberOfChildren !== null"
      :initialFeatures="features"
      :initialGroup="group"
      :initialNumberOfAdults="numberOfAdults"
      :initialNumberOfChildren="numberOfChildren"
      :initialNumberOfRooms="1"
      :maximumNumberOfAdults="maximumNumberOfAdults"
      :maximumNumberOfChildren="maximumNumberOfChildren"
      :maximumNumberOfGuests="maximumNumberOfGuests"
      :maximumNumberOfRooms="maximumNumberOfRooms"
      :minimumNumberOfAdults="minimumNumberOfAdults"
      :minimumNumberOfChildren="minimumNumberOfChildren"
      :minimumNumberOfRooms="minimumNumberOfRooms"
      :showCart="false"
      :showGroupSelector="true"
      @change="filterBuildings"
      /> !-->
  </div>
</template>

<script>
//import AvailabilityFilters from './AvailabilityFilters.vue';
import Slick from 'vue-slick';
import filterMixin from '@/mixins/filterMixin';
import {
  areFeaturesValid,
  getNumberWithinRangeElseDefault,
  isGroupValid,
  isNumberOfGuestsValid,
} from '@/utils/BookingDetailValidationUtil'

export default {
  mixins: [
    filterMixin,
  ],
  data() {
    /* global wpData:true */
    /* eslint no-undef: "error" */
    return {
      buildingListingKey: Number(new Date()),
      buildings: [],
      filteredBuildings: [],
      datesProvided: null,
      defaultNumberOfAdults: 2,
      defaultNumberOfChildren: 0,
      defaultNumberOfInfants: 0,
      features: null,
      group: null,
      loading: false,
      maximumNumberOfAdults: 10,
      maximumNumberOfChildren: 10,
      maximumNumberOfGuests: 10,
      maximumNumberOfRooms: 4,
      minimumNumberOfAdults: 1,
      minimumNumberOfChildren: 0,
      minimumNumberOfRooms: 1,
      numberOfAdults: null,
      numberOfChildren: null,
      numberOfInfants: null,
      translations: null,
      wpData,
      slickOptions: {
        arrows: true,
        dots: false,
        prevArrow: '<div class="prev"><svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><title>arrow-left</title><path fill="#fff" d="M28.393,35.362l-9.908-9.948a2.007,2.007,0,0,1,0-2.828l9.908-9.948,1.417,1.411L19.9,24l9.908,9.954Z"/></svg></div>',
        nextArrow: '<div class="next"><svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><title>arrow-right</title><path fill="#fff" d="M19.607,35.362,18.19,33.951,28.1,24,18.19,14.049l1.417-1.411,9.908,9.948a2.007,2.007,0,0,1,0,2.828Z"/></svg></div>',
        infinite: true,
        adaptiveHeight: false,
        speed: 300,
        cssEase: 'cubic-bezier(0, 0, 0.04, 0.98)',
        focusOnSelect: false,
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnFocus: false,
        pauseOnHover: false,
        autoplay: false
      },
    };
  },
  components: {
    //'availability-filters': AvailabilityFilters,
    'slick': Slick
  },
  async mounted() {
    this.setLocale();

    this.buildings = this.wpData.buildings || []
    this.filteredBuildings = this.wpData.buildings || []

    this.initialiseBookingDetails()
  },
  methods: {
    initialiseBookingDetails() {
      this.numberOfAdults = getNumberWithinRangeElseDefault(
          this.wpData.query_parameters.minAdults,
          this.defaultNumberOfAdults,
          this.minimumNumberOfAdults,
          this.maximumNumberOfAdults
      );

      this.numberOfChildren = getNumberWithinRangeElseDefault(
          this.wpData.query_parameters.minChildren,
          this.defaultNumberOfChildren,
          this.minimumNumberOfChildren,
          this.maximumNumberOfChildren
      );

      this.numberOfInfants = getNumberWithinRangeElseDefault(
          this.wpData.query_parameters.minInfants,
          this.defaultNumberOfInfants,
          0,
          10
      );

      if (areFeaturesValid(this.wpData.query_parameters.features)) {
        this.features = this.wpData.query_parameters.features;
      } else {
        this.features = '';
      }

      if (isGroupValid(this.wpData.query_parameters.group)) {
        this.group = this.wpData.query_parameters.group;
      } else {
        this.group = '';
      }

      this.filterBuildings()
    },
    buildingImages(building) {
      const mainImages = building.main_images || []

      return mainImages.map(image => image.url)
    },
    buildingBedroomsText(building) {
      const rooms = building.rooms || []

      const numberOfBedrooms = rooms.map(room => Number(room.number_of_bedrooms) || 0)
      const lowestNumberOfBedrooms = Math.min(...numberOfBedrooms)
      const highestNumberOfBedrooms = Math.max(...numberOfBedrooms)

      if (lowestNumberOfBedrooms === Infinity || lowestNumberOfBedrooms === -Infinity) {
        return 0
      }

      if (lowestNumberOfBedrooms === highestNumberOfBedrooms) {
        return `${lowestNumberOfBedrooms} ${this.$t('bedrooms')}`
      }

      return `${lowestNumberOfBedrooms} - ${highestNumberOfBedrooms} ${this.$t('bedrooms')}`
    },
    highestMaximumOccupancyExcludingInfants(building) {
      const rooms = building.rooms || []

      const numberOfResidents = Math.max(
          ...rooms.map(room => Number(room.maximum_occupants) || 0)
      )

      return numberOfResidents === Infinity || numberOfResidents === -Infinity ? 0 : numberOfResidents
    },
    filterBuildings(event = {}) {
      if (event.emittedFromDatePicker === true) {
        this.buildingListingKey = event.currentDateSelectionKey

        return
      }

      this.numberOfAdults = event.numberOfAdults || this.numberOfAdults
      this.numberOfChildren = event.numberOfChildren || this.numberOfChildren
      this.features = event.features || ''
      this.group = event.group || ''

      this.loading = true
      setTimeout(() => this.loading = false, 600)

      this.filteredBuildings = this.buildings.filter(
        (building) => {
          const selectedGroup = event.group || ''

          if (selectedGroup !== '' && building.group !== '' && selectedGroup !== building.group) {
            return false
          }

          const rooms = building.rooms || []

          const roomFeatures = []

          rooms.forEach(
              (room) => {
                const features = room.autoloaded_features || []

                features.forEach(feature => roomFeatures.push(feature.value))
              }
          )

          const selectedFeatures = this.features.split(',').filter(feature => feature.length)
          const doesRoomMatchSomeSelectedFilters = selectedFeatures.some(feature => roomFeatures.includes(feature))

          if (selectedFeatures.length !== 0 && doesRoomMatchSomeSelectedFilters === false) {
            return false
          }

          return isNumberOfGuestsValid(
              this.numberOfAdults,
              this.numberOfChildren,
              this.numberOfInfants,
              this.highestMaximumOccupancyExcludingInfants(building)
          )
        }
      )
    },
    setLocale() {
      const url = new URL(window.location.href);
      const language = url.searchParams.get('lang');

      this.$i18n.locale = document.getElementsByTagName('html')[0].getAttribute('lang');

      if (this.$i18n.availableLocales.indexOf(language) === -1) {
        this.translations = this.$i18n.messages[this.$i18n.fallbackLocale];
      } else {
        this.translations = this.$i18n.messages[language];
      }
    },
  },
  computed: {
    showNoAvailabilityErrorMessage: function() {
      return this.filteredBuildings.length === 0
    }
  },
}
</script>
